'use client';
import { InitFlow, MaintenanceFlowBuilder } from '@capsicum/common';
import { CookieConsentBanner, Maintenance, PwaForceInstallFlowAndroid } from '@capsicum/common-web';
import { GoogleAdsConsentFlow, LocaleSetupFlow } from '@capsicum/features/account/web';
import { NCWInitFlow } from '@capsicum/features/nc-onboarding/web';
import { V2FTMigrationInitFlow } from '@capsicum/features/nc-wallet/web';
import { IsOnboardingCompleted } from '@capsicum/features/onboard/shared';
import { InterestsFlow } from '@capsicum/features/onboard/web';
import { ForcedRequirementsCheckerFlow } from '@capsicum/features/regulations/web';
import {
	AlmostCompleteRegistrationCheckerFlow,
	FavoriteTeamCheckerFlow,
	GreetingsFlow,
	USUserDisabledFlow
} from '@capsicum/socios-core-web';
import { type ReactNode } from 'react';

const INIT_FLOW_QUEUE = [
	V2FTMigrationInitFlow,
	MaintenanceFlowBuilder(Maintenance),
	PwaForceInstallFlowAndroid,
	USUserDisabledFlow,
	ForcedRequirementsCheckerFlow,
	IsOnboardingCompleted,
	InterestsFlow,
	FavoriteTeamCheckerFlow,
	GreetingsFlow,
	AlmostCompleteRegistrationCheckerFlow,
	NCWInitFlow,
	LocaleSetupFlow,
	GoogleAdsConsentFlow
];

export default function AuthenticatedInitFlow({ children }: { children: ReactNode }) {
	return (
		<InitFlow components={INIT_FLOW_QUEUE} fallback={null}>
			<CookieConsentBanner />
			{children}
		</InitFlow>
	);
}
